import React, {useEffect, useState} from 'react';
import {Grid2 as Grid, Paper, TableContainer, Table, TableHead, TableRow, TableCell, Typography, TableBody} from '@mui/material';
import SavingItem from '../../../types/reports/savingItem';

interface Props {
   items?:SavingItem[];
}

interface SavingGroup {
    groupName: string;
    items: SavingItem[];
}


const SavingsScheduleTable = (props: Props): JSX.Element => {

 const [groupData, setGroupData] = useState<SavingGroup[]>();

 useEffect(() => {
    if(props.items){
        let items = props.items;
        let groups: SavingGroup[] = [];
        items.forEach((item: SavingItem) => {
          let groupName = item.accountName;
          let groupIndex = groups.findIndex((group) => group.groupName === groupName);
          if (groupIndex> -1){
              groups[groupIndex].items.push(item);
          }else{
              groups.push({
              groupName: item.accountName,
              items: [item]
            });
          }
        })
        setGroupData(groups);
    }
 }, [props.items])

    return (
        <Grid container spacing={1}>
         <TableContainer component={Paper} sx={{ maxHeight: 800 }}>
             <Table stickyHeader aria-label="savings schedule table" size="small">
                 <TableHead>
                     <TableRow>
                         <TableCell>
                             <Typography variant={'subtitle2'} fontWeight={600}>
                                Date
                             </Typography>
                         </TableCell>
                         <TableCell>
                             <Typography variant={'subtitle2'} fontWeight={600}>
                                Transaction Type
                             </Typography>
                         </TableCell>
                         <TableCell>
                            <Typography variant={'subtitle2'} fontWeight={600}>
                                Amount	
                            </Typography>
                        </TableCell>
                     </TableRow>
                 </TableHead>
                 <TableBody>
                     {groupData?.map((group: SavingGroup, i) => (
                         <>
                            <TableRow key={i} sx={{ bgcolor: 'alternate.dark' }}>
                                <TableCell colSpan={8}>
                                    <Typography variant={'subtitle2'} fontWeight={650}>{group.groupName}</Typography>
                                </TableCell>
                            </TableRow>
                            {
                                group.items.map((item: SavingItem, j) => (
                                    <TableRow
                                    key={j}
                                    sx={{
                                        '&:last-child td, &:last-child th': { border: 0 },
                                    }}
                                    >
                                        <TableCell>
                                            <Typography variant={'subtitle2'}>
                                                {item.date}
                                            </Typography>
                                        </TableCell> 
                                        <TableCell>
                                            <Typography variant={'subtitle2'}>
                                                {item.recordTypeDescription}
                                            </Typography>
                                        </TableCell> 
                                        <TableCell align='right'>
                                            <Typography variant={'subtitle2'}>
                                                {item.liabilityEffectAmountDisplay}
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                ))
                            }
                         </>  
                    ))}
                 </TableBody>
             </Table>
         </TableContainer>
        </Grid>
    );
}

export default SavingsScheduleTable;